<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="m-0 background-primary-blue height-70px shadow z-max d-flex justify-content-center align-items-center">
        <div class="text-center color-white p-4 fs-lg">Notifications</div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        @if (notificationsStore.sortedNotifications().length > 0) {
            <span (click)="dismissAll()"
                class="color-danger fw-bold pointer align-self-center user-select-none dismiss-all">Dismiss all notifications</span>
            <div [ngClass]="{'deleted': deleted}"
                #notificationsWrapper
                class="d-flex flex-column p-3 gap-3 notifications-wrapper">
                @for (notification of notificationsStore.sortedNotifications(); track notification.id) {
                    <app-notification [asset]="assetsStore.assetsById().get(notification.assetId!)"
                        [notification]="notification"></app-notification>
                }
            </div>
        }
    </div>
</div>
